export { default as NGDatepicker } from './NGDatepicker';
export type {
  DatePickerProps,
  DatePickerExactProps,
  DatePickerFlexibleProps,
  FocusedInputType,
} from './NGDatepicker.types';
